


import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  IconButton,
  TextField,
  Box,
  Breadcrumbs,
  Autocomplete,
  useMediaQuery,
  InputAdornment,
  Link, Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { Packagedata, sampleData } from "../../components/grid/GridData";
import externaldeletecomApi, { externalgetApi } from "../../services/externalApis";
import { SETTING_API_01, SETTING_API_06, } from "../../api/ApiModel";
import ViewDataGrid from "../../components/grid/ViewDataGrid";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import { PageDataContext } from "../../utils/common/PageDataContext";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import DeleteIcon from '@mui/icons-material/Delete';
import SystemAlert from "../../components/common/SystemAlert";

function ViewPackage() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const SYS_USER = useSelector((state) => state.user) || {};
  const {    LOCCODE,STAFFMAPLOCODE,COMPCODE,USERNAME } = SYS_USER.USER_PARAM || {};
  const [isLoading, setIsLoading] = useState(false);
 const [filteredRows, setFilteredRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // State for search input
  const [data, setData] = useState(null);
     const [alertOpen, setAlertOpen] = useState(false); // State to control alert visibility
    const [alertType, setAlertType] = useState("success"); // Type of alert (e.g., success, error, warning)
    const [alertMessage, setAlertMessage] = useState("");
   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
  const [error, setError] = useState({});
  useEffect(() => {
    setPageData({
      title: "Package",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);


  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.packagecode === id);
      if (selectedItem) {
        navigate(`/CreatePackages`, { state: { selectedItem, actionText } });
      }
    }
    if (actionText === "Delete") {
      setSelectedId(id);
      setOpenDeleteDialog(true); // open dialog
    }
    };

    const confirmDelete = async () => {
      try {
        setIsLoading(true);
    
        await externaldeletecomApi(`${SETTING_API_06}/${selectedId}`, {
          packagecode: String(selectedId),
          ENUSER: USERNAME || "ss",
        });
    
        setData((prev) => prev?.filter((row) => row.packagecode !== selectedId));
        setFilteredRows((prev) => prev?.filter((row) => row.packagecode !== selectedId));
    
        setAlertMessage("Package deleted successfully");
        setAlertType("success");
        setAlertOpen(true);
      } catch (error) {
        console.error("DELETE API error:", error);
    
        // Try to extract the API error message
        const errorMessage =
          error?.response?.data?.message || // if backend returns { message: "..." }
          error?.response?.data ||         // fallback: raw data
          error?.message ||                // fallback: JS error message
          "Failed to delete brand.";
    
        setAlertMessage(errorMessage);
        setAlertType("error");
        setAlertOpen(true);
      } finally {
        setIsLoading(false);
        setOpenDeleteDialog(false);
        setSelectedId(null);
      }
    };
    
    
      const cancelDelete = () => {
        setOpenDeleteDialog(false);
        setSelectedId(null);
      };
  
    const menuItems = [
      {
        text: "Edit",
        icon: <BorderColorOutlinedIcon />,
      onClick: (packagecode) => handleItemClick(packagecode, "Edit"),
      },
       {
              text: "Delete",
              icon: <DeleteIcon />,
        onClick: (packagecode) => handleItemClick(packagecode, "Delete"),
            },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
      const result = await externalgetApi(SETTING_API_06, "get", {
        COMPCODE,
          LOCCODE:STAFFMAPLOCODE,
        
    
          STS: CON_STATUS_ACTIVE,
        });

        setData(result);
        setFilteredRows(result); // Initialize filtered rows with all data
      console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);


  // Handle search input change
  const handleSearchChange = (event, value) => {
    setSearchQuery(value); // Update search query state

    // Filter rows based on search query
    const filtered = data?.filter((row) =>
      row.packagename.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredRows(filtered || []);
  };

  const addToView = () => {
    navigate("/CreatePackages");
  };

  return (
    <>
      <Box sx={styles.box_breadcrumb_view}>
     <Breadcrumbs
                 separator="›"
                 aria-label="breadcrumb"
                 sx={styles.breadcrumb}
               >
                 <Link
                   underline="hover"
                   sx={styles.breadcrumb_link}
                   // href=""
                 >
                   Home
                 </Link>
                 <Link
                   sx={styles.breadcrumb_link}
                   underline="hover"
                   // href=""
                 >
                   Settings
                 </Link>
                 <Link
                   sx={styles.breadcrumb_link_page}
                   underline="hover"
                   // href="#"
                   aria-current="page"
                 >
               Package
                 </Link>
               </Breadcrumbs>
      </Box>

      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 6, lg: 8, xl: 8 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {Packagedata.name}
              </Typography>
            </Grid>

            <Grid
              item
              size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}
              sx={styles.appbar_grid_search}
            >
                <Autocomplete
                freeSolo
                id="sample-search"
                fullWidth
                disableClearable
                value={searchQuery}
                onInputChange={handleSearchChange} // Handle search input change
                sx={styles.ipt_appbar_search_auto}
                options={data?.map((row) => row.packagename) || []} // Provide options for autocomplete
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search by..."
                    size="small"
                    sx={styles.ipt_appbar_search}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton sx={styles.btn_appbar_search_icon}>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />


              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                size="small"
                sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                onClick={addToView}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </AppBar>

        <Box sx={styles.view_page_container}>
        <ViewDataGrid
  columns={Packagedata.columns}
  rows={filteredRows.map((row) => ({
    ...row,
    id: row.packagename || Math.random(),
  }))} // Ensure each row has a unique id
  getRowId={(row) => row.id} // Use the id property for unique identification
  isLoading={isLoading}
  menuItems={menuItems}
  tabletitle={Packagedata.name}
  gridid="packagecode"
  sx={styles.view_data_grid_page}
/>
        </Box>
      </Box>

        <SystemAlert
                      open={alertOpen}
                      type={alertType}
                      message={alertMessage}
                      onClose={() => setAlertOpen(false)}
                    />
            
                      <Dialog
                    open={openDeleteDialog}
                    onClose={cancelDelete}
                    aria-labelledby="delete-dialog-title"
                  >
                    <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Are you sure you want to delete this Package? 
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={cancelDelete} 
                        sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
                      color="inherit">
                        Cancel
                      </Button>
                      <Button onClick={confirmDelete} color="error"
                       sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
                       variant="contained">
                        Delete
                      </Button>
                    </DialogActions>
                  </Dialog>
    </>
  );
}
export default ViewPackage;
